module.exports = __webpack_public_path__ + "img/objFolder.21bf59bc.svg";